import { margin, styled, Text } from '@thg-commerce/enterprise-theme'
import { TextStyling } from '@thg-commerce/gravity-theme'

export const ProductStockInformationText = styled.p<{
  textStyle?: TextStyling
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'default',
    )};
  ${margin({ top: 1, bottom: 0.5 })}
  text-transform: ${(props) => props.textStyle?.transform};
  color: ${(props) =>
    props.textStyle?.textColor || props.theme.colors.palette.brand.base};
`

export const ProductLaunchDateText = styled.p`
  ${Text('bodyText', 'default')};
  ${margin({
    top: 4,
  })};
  color: ${(props) => props.theme.colors.palette.brand.base};
`
